import { calendarDetailed } from '@app/pcs/models';
import { gql } from 'apollo-angular';

export const updateValidityPeriodQuery = gql`
  query UpdateValidityPeriod(
    $templateCalendar: CalendarInput!, $validityPeriod: ValidityPeriodInput!, $existingPath: Boolean!
  ) {
    updateValidityPeriod(templateCalendar: $templateCalendar, validityPeriod: $validityPeriod, existingPath: $existingPath) {
      ...calendarDetailed
    }
  }
  ${calendarDetailed}
`;
